<div class="modal-header"><h2>Create a new APSIS One account</h2></div>
<ng-template #createAccount>
  <app-create-account-form
    [state]="formState$ | async"
    (createAccount)="onSubmit($event)"
    [accountCategories]="accountCategories$ | async"
    [userPermissions]="userPermissions$ | async"
    [licensePackages]="licensePackages$ | async"
    [isLoadingPackages]="isLoadingPackages$ | async"
    [licensePackagesError]="licensePackagesError$ | async"
  ></app-create-account-form>
</ng-template>
<div *ngIf="(formState$ | async) === FormState.success; else createAccount">
  <div class="modal-body">
    <app-account-status
      [accountStatus]="accountStatus$ | async"
      [isBootstrapComplete]="isBootstrapComplete$ | async"
    ></app-account-status>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-dark"
      (click)="activeModal.close()"
      [disabled]="!(isBootstrapComplete$ | async)"
    >
      Close
    </button>
  </div>
</div>
